var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.80292 13.6364C5.51003 13.9293 5.51003 14.4041 5.80292 14.697C6.09582 14.9899 6.57069 14.9899 6.86358 14.697L5.80292 13.6364ZM15.1969 6.3637C15.4898 6.07081 15.4898 5.59594 15.1969 5.30304C14.904 5.01015 14.4291 5.01015 14.1363 5.30304L15.1969 6.3637ZM14.1363 14.697C14.4291 14.9899 14.904 14.9899 15.1969 14.697C15.4898 14.4041 15.4898 13.9293 15.1969 13.6364L14.1363 14.697ZM6.86358 5.30304C6.57069 5.01015 6.09582 5.01015 5.80292 5.30304C5.51003 5.59594 5.51003 6.07081 5.80292 6.3637L6.86358 5.30304ZM6.86358 14.697L15.1969 6.3637L14.1363 5.30304L5.80292 13.6364L6.86358 14.697ZM15.1969 13.6364L6.86358 5.30304L5.80292 6.3637L14.1363 14.697L15.1969 13.6364Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.3ef6e43e173d0431a377213643b3abd1.svg";
export { ForwardRef as ReactComponent };